module.exports = __webpack_public_path__ + "img/sn.c4f3d421.svg";